import React from 'react';
import PropTypes from 'prop-types';
import { useDragLayer } from 'react-dnd';

import './DragLayer.styles.less';

function getStyles(currentOffset, initialClientOffset, initialSourceClientOffset) {
  if (!currentOffset || !initialClientOffset || !initialSourceClientOffset)
    return { display: 'none' };
  return {
    top: 0,
    left: 0,
    transform: `translate(${currentOffset.x}px, ${
      currentOffset.y + (initialClientOffset.y - initialSourceClientOffset.y + 1)
    }px)`,
  };
}

const DragLayer = ({ numSelectedGuests }) => {
  const {
    isDragging,
    item,
    currentOffset,
    initialSourceClientOffset,
    initialClientOffset,
  } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    initialClientOffset: monitor.getInitialClientOffset(),
    initialSourceClientOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging || item == null || item.item === 'table' || item.seat == null) return null;

  const DragCount =
    numSelectedGuests !== undefined && numSelectedGuests > 1 ? (
      <div className="sprite__num-dragged">
        <div className="sprite__num-circle">{numSelectedGuests}</div>
      </div>
    ) : null;
  const positionStyle = getStyles(currentOffset, initialClientOffset, initialSourceClientOffset);
  const name =
    item.displayName !== null ? (
      item.displayName
    ) : (
      <div>
        {item.firstName} <b>{item.lastName}</b>
      </div>
    );

  return (
    <div className="sc__drag-layer">
      <div className="sc__drag-sprite" style={positionStyle}>
        {DragCount !== null && <div className="sprite__bottom" />}
        <div className="sprite__top">
          <div className="sprite__guest-name">{name}</div>
          {DragCount}
        </div>
      </div>
    </div>
  );
};

DragLayer.propTypes = {
  numSelectedGuests: PropTypes.number,
};

export default DragLayer;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/DragLayer/DragLayer.jsx